<template>
    <defaultSec class="work-order-list">
        <template #title>
            <div  class="default-header" style="display: flex;justify-content: space-between">
                <h3>工单管理</h3>
                <div>
                        <el-button style="float: right; padding: 5px 10px" type="danger" @click="toInstructions" icon="el-icon-s-claim">工单管理指导手册</el-button>
                </div>

            </div>

        </template>
        <el-form :inline="true" :model="formParam" class="demo-form-inline select-wrap" size="mini">
            <el-form-item label="购买渠道">
                <el-radio-group size="mini" v-model="formParam.orderOnline">
                    <el-radio-button :label="null">全部</el-radio-button>
                    <el-radio-button :label="1">线上</el-radio-button>
                    <el-radio-button :label="2">线下</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="售后问题">
              <el-cascader
                  size="small"
                  style="width: 100%"
                  clearable
                  v-model="formParam.issueCode"
                  :options="issueOptions"
                  :props="{ emitPath: false }"
                  placeholder="请选择">
              </el-cascader>
            </el-form-item>
            <el-form-item label="外部单号">
                <el-input v-model="formParam.someID" placeholder="请填写" clearable></el-input>
            </el-form-item>
            <el-form-item label="工单状态">
                <el-select size="small" style="width: 100%" clearable v-model="formParam.workOrderStatus" placeholder="请选择">
                    <el-option
                        v-for="item in statusList"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建人">
                <el-select style="width: 100%" filterable v-model="formParam.createUserId" placeholder="请选择" clearable>
                    <el-option
                        v-for="item in userList"
                        :key="item.USER_ID"
                        :label="userDisplayName(item)"
                        :value="item.USER_ID">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="当前处理人">
                <el-select style="width: 100%" filterable v-model="formParam.handleUserId" placeholder="请选择" clearable>
                    <el-option
                        v-for="item in userList"
                        :key="item.USER_ID"
                        :label="userDisplayName(item)"
                        :value="item.USER_ID">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="责任部门">
                <el-select filterable style="width: 100%" v-model="formParam.dingDeptId" placeholder="请选择">
                    <el-option
                        v-for="item in deptList"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                    clearable
                    v-model="formParam.createTimeStr"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="initList">查询</el-button>
                <el-button type="warning" @click="toDetail(0)">新建工单</el-button>
            </el-form-item>
        </el-form>
        <tablePagination :total="total" :pageSize="formParam.pageSize" :currentPage="formParam.pageNum" @handlePage="handlePage">
            <el-table v-loading="loading" :data="tableList" border size="mini">
                <el-table-column type="index" label="序号"></el-table-column>
<!--                <el-table-column prop="workOrderNo" label="工单编号"></el-table-column>-->
                <el-table-column prop="orderOnline" label="购买渠道" width="80">
                  <template slot-scope="scope">
                    <i style="color: #1593eb;font-size: 14px" :class="scope.row.orderOnline=='线上'?'el-icon-goods':'el-icon-s-shop'"></i>
                    {{scope.row.orderOnline}}
                  </template>
                </el-table-column>
                <el-table-column prop="workOrderTypeName" label="售后问题" minWidth="220">
                    <template slot-scope="scope">
                        <div class="label-text"><b>问题大类：</b><span>{{scope.row.workOrderTypeGroup || '-'}}</span></div>
                        <div class="label-text"><b>具体问题：</b><span>{{scope.row.workOrderTypeName || '-'}}</span></div>
                        <div class="label-text" v-if="scope.row.workOrderTypeGroup === '质量'">
                            <b>产品线：</b><span>{{scope.row.workOrderTypeMatClass || '-'}}</span>
                        </div>
                        <div class="label-text" v-if="scope.row.workOrderTypeGroup === '质量'">
                            <b>工厂：</b><span>{{scope.row.workOrderTypeFactory || '-'}}</span>
                        </div>
                        <div class="label-text" v-if="scope.row.workOrderTypeGroup === '运营'">
                            <b>店铺：</b><span>{{scope.row.onlineShopName || scope.row.workOrderTypePlatform || '-'}}</span>
                        </div>
                        <div class="label-text"><b>问题描述：</b><span class="copy-text">{{scope.row.workOrderDesc}}</span></div>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNo" label="订单信息" min-width="220">
                    <template slot-scope="scope">
                        <div class="label-text" v-if="scope.row.orderNo"><b>订单编号：</b><span>{{scope.row.orderNo}}</span></div>
                        <div class="label-text" v-if="scope.row.refundNo"><b>售后单号：</b><span>{{scope.row.refundNo}}</span></div>
                        <div class="label-text" v-if="scope.row.offlineOrderNo"><b>线下单号：</b><span>{{scope.row.offlineOrderNo}}</span></div>
                        <div class="label-text" style="display: block" v-if="scope.row.productList&&scope.row.productList.length>0"><b>售后商品：</b>
                            <span class="copy-text">
                                <span
                                    v-for="(item,index) in scope.row.productList"
                                    :key="`${scope.row.workOrderNo || 'work-order'}-${item.productCode || item.productName || index}-${index}`"
                                    style="display:block;font-weight: normal;margin-bottom: 5px">
                                    <i style="color:#dfb81d">● </i>
                                    {{item.productName}}{{item.productPici?'（'+item.productPici+'）':''}}
                                </span>
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="商品温层" width="90">
                    <template slot-scope="scope">
                        <el-tag size="mini" :type="temperatureZoneTagType(scope.row.temperatureZone)">
                            {{temperatureZoneText(scope.row.temperatureZone)}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="沟通状态" min-width="150">
                    <template slot-scope="scope">
                        <el-tag size="mini" :type="communicationStatusTagType(scope.row.communicationStatus)">
                            {{communicationStatusText(scope.row.communicationStatus)}}
                        </el-tag>
                        <div v-if="scope.row.productionQuestion" class="status-detail">
                            <b>待回复：</b>{{scope.row.productionQuestion}}
                        </div>
                        <div v-else-if="scope.row.communicationResult" class="status-detail">
                            <b>沟通结果：</b>{{scope.row.communicationResult}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="通知状态" width="90">
                    <template slot-scope="scope">
                        <el-tag size="mini" :type="notificationStatusTagType(scope.row.notificationStatus)">
                            {{notificationStatusText(scope.row.notificationStatus)}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="工单状态" width="80">
                    <template slot-scope="scope">
                        <span :style="{color: scope.row.workOrderStatus==0?'#999999':(scope.row.workOrderStatus==1?'#dfb81d':(scope.row.workOrderStatus==10?'green':'#e85656'))}">● {{scope.row.workOrderStatusName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="workOrderResult" label="工单处理" min-width="220">
                    <template slot-scope="scope">
                        <div class="label-text"><b>处理人员：</b><span>{{scope.row.handleUserId}}</span></div>
                        <div class="label-text" v-if="scope.row.responsibleDeptDingdingId"><b>责任部门：</b>
                            <span class="response-dept">
                                <el-dropdown size="small" split-button type="success" @command="(key)=>handleCommand(key,scope.row)">
                                     {{scope.row.responsibleDeptDingdingId}}
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            v-for="item in deptList"
                                            :key="item.key"
                                            :command="item.key">
                                            {{item.name}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </span>
                        </div>
                        <div class="label-text" v-if="scope.row.workOrderResult"><b>处理结果：</b><span>{{scope.row.workOrderResult}}</span></div>
                        <div class="label-text" v-if="scope.row.workOrderResultDesc"><b>结果描述：</b><span class="copy-text">{{scope.row.workOrderResultDesc}}</span></div>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建信息">
                    <template slot-scope="scope">
                        <p>{{scope.row.createUserId}}</p>
                        <p>{{scope.row.createTime}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="160">
                    <template slot-scope="scope">
                        <el-button style="margin-right: 8px" type="danger" plain size="mini" @click="toDetail(scope.row.workOrderNo)">查看</el-button>
                        <el-popconfirm
                            v-if="scope.row.workOrderStatus!=0&&scope.row.workOrderStatus!=10"
                            title="确定要作废这条工单吗？"
                            @confirm="delWorkOrder(scope.row.workOrderNo)"
                        >
                            <el-button slot="reference" type="warning" plain size="mini">作废</el-button>

                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </tablePagination>
    </defaultSec>
</template>

<script>
import defaultSec from '@c/defaultSection'
import tablePagination from '@c/tablePagination'

const FILTER_QUERY_KEYS = [
    'orderOnline',
    'issueCode',
    'someID',
    'workOrderStatus',
    'createUserId',
    'handleUserId',
    'dingDeptId',
    'createTimeStart',
    'createTimeEnd'
]

function getQueryValue(value) {
    const normalizedValue = Array.isArray(value) ? value[0] : value
    return normalizedValue === undefined || normalizedValue === null || normalizedValue === ''
        ? null
        : normalizedValue
}

function getNumberQueryValue(value) {
    const normalizedValue = getQueryValue(value)
    if (normalizedValue === null) {
        return null
    }
    const numberValue = Number(normalizedValue)
    return Number.isNaN(numberValue) ? null : numberValue
}

export default {
    name: "workOrderList",/*此处的name必须有且与include中的一致*/
    data() {
        const query = this.$route.query || {}
        const createTimeStart = getQueryValue(query.createTimeStart)
        const createTimeEnd = getQueryValue(query.createTimeEnd)
        return {
            formParam:{
                pageSize:10,
                pageNum:Number(this.$route.params.pageNum)||1,
                orderOnline:getNumberQueryValue(query.orderOnline),
                issueCode:getQueryValue(query.issueCode),
                someID:getQueryValue(query.someID),
                workOrderStatus:getNumberQueryValue(query.workOrderStatus),
                createUserId:getQueryValue(query.createUserId),
                handleUserId:getQueryValue(query.handleUserId),
                dingDeptId:getQueryValue(query.dingDeptId),
                createTimeStr:createTimeStart && createTimeEnd ? [createTimeStart, createTimeEnd] : null,
            },
            tableList:[],
            userList:[],
            deptList:[],
            issueOptions:[],
            statusList:[],
            total:0,
            formData:{},
            addWorkOrderVisible:false,
            loading:true
        }
    },
    components:{
        defaultSec,tablePagination
    },
    mounted(){
        this.initIssueOptions()
        this.initUserList()
        this.initStatusList()
        this.initDeptList()
        this.initList()
    },
    activated(){
    },
    methods: {
        userDisplayName(user){
            return user ? (user.USER_NAME || user.USER_NICK || user.USER_ID) : '-'
        },
        temperatureZoneText(value){
            return {COLD:'低温',AMBIENT:'常温',UNKNOWN:'待确认'}[value] || '待确认'
        },
        temperatureZoneTagType(value){
            return {COLD:'',AMBIENT:'success',UNKNOWN:'warning'}[value] || 'warning'
        },
        communicationStatusText(value){
            return {
                PENDING_REPLY:'待生产回复',
                REPLIED:'生产已回复',
                RESULT_AVAILABLE:'已有沟通结果',
                NO_REPLY_REQUIRED:'无需生产回复',
            }[value] || '未设置'
        },
        communicationStatusTagType(value){
            return {
                PENDING_REPLY:'warning',
                REPLIED:'success',
                RESULT_AVAILABLE:'',
                NO_REPLY_REQUIRED:'info',
            }[value] || 'info'
        },
        notificationStatusText(value){
            return {
                NONE:'无通知',
                PENDING:'待发送',
                SUCCESS:'发送成功',
                FAILED:'发送失败',
            }[value] || '无通知'
        },
        notificationStatusTagType(value){
            return {
                NONE:'info',
                PENDING:'warning',
                SUCCESS:'success',
                FAILED:'danger',
            }[value] || 'info'
        },
        getFilterRouteQuery() {
            const query = {...this.$route.query}
            FILTER_QUERY_KEYS.forEach(key => {
                delete query[key]
            })
            const filterKeys = [
                'orderOnline',
                'issueCode',
                'someID',
                'workOrderStatus',
                'createUserId',
                'handleUserId',
                'dingDeptId'
            ]
            filterKeys.forEach(key => {
                const value = this.formParam[key]
                if (value !== undefined && value !== null && value !== '') {
                    query[key] = value
                }
            })
            if (this.formParam.createTimeStr && this.formParam.createTimeStr.length === 2) {
                query.createTimeStart = this.formParam.createTimeStr[0]
                query.createTimeEnd = this.formParam.createTimeStr[1]
            }
            return query
        },
        handleRouterError(error) {
            if (!error || error.name !== 'NavigationDuplicated') {
                this.$message({
                    message: '工单列表状态保存失败，请重试',
                    type: 'error'
                })
            }
        },
        syncFilterRouteQuery() {
            return this.$router.replace({
                query: this.getFilterRouteQuery()
            }).catch(error => this.handleRouterError(error))
        },
        initList(syncRouteQuery = true) {
            if (syncRouteQuery) {
                this.syncFilterRouteQuery()
            }
            this.loading = true
            let param = {...this.formParam};
            param.createTimeStr = param.createTimeStr?param.createTimeStr.join(','):null;
            this.$apiGet('lechun-csms/workOrder/workOrderList',param).then(res => {
                this.loading = false
                this.total = res.total;
                this.tableList = res.list

            })
        },
        initUserList() {
            this.$apiGet('lechun-baseservice/user/getUserListForDorpbox',{}).then(res => {
                this.userList = res || []

            })
        },
        initDeptList() {
            this.$apiGet('lechun-csms/workOrder/getWorkOrderResponseDept',{}).then(res => {
                this.deptList = res

            })
        },
        initStatusList() {
            this.$apiGet('lechun-csms/workOrder/workOrderStatusSimple',{}).then(res => {
                this.statusList = res

            })
        },
        initIssueOptions() {
            this.$apiGet('lechun-csms/workOrder/classification/issues',{includeDisabled:true}).then(res => {
                this.issueOptions = res || []
            })
        },
        delWorkOrder(id) {
            this.$apiGet('lechun-csms/workOrder/deleteWorkOrder',{ workOrderNo:id}).then(() => {
                this.$message({
                    message: '工单已作废',
                    type: 'success'
                })
                this.initList()

            })
        },
        handlePage(page){
            this.formParam.pageNum = page;
            this.$router.push({
                name: 'workOrderList',
                params: {pageNum: page},
                query: this.getFilterRouteQuery()
            }).catch(error => this.handleRouterError(error))
            this.initList(false)

        },
        toDetail(id){
            this.syncFilterRouteQuery().then(() => {
                this.$router.push({
                    name: 'workOrderDetail',
                    params: {id: id},
                    query: {
                        editAble: 1
                    }
                }).catch(error => this.handleRouterError(error))
            })
        },
        toInstructions(){
            window.open('https://alidocs.dingtalk.com/i/nodes/ydxXB52LJq7YOprLFqxjLnBGWqjMp697?cid=4448346107&corpId=ding5473140ac462716435c2f4657eb6378f&doc_type=wiki_doc&iframeQuery=utm_medium=im_card&utm_source=im&utm_medium=im_card&utm_scene=person_space&utm_source=im','_blank')
        },
        handleCommand(key,item){
            this.$apiGet('lechun-csms/workOrder/saveRespDept',{  dingDeptId:key,workOrderNo:item.workOrderNo}).then(() => {
                this.$message({
                    message: '责任部门已修改成功',
                    type: 'success'
                })
                this.initList()

            })
        }
    }
}
</script>


<style lang="scss">
.work-order-list{
    .label-text{
        display: flex;
        margin-bottom: 5px;
        b{
            width: 60px;
            display: block;
            text-align: right;
            font-weight: normal;
        }
        >span{
            flex: 1;
            font-weight: bolder;
        }
    }
    .copy-text {
        display: block;
        white-space: pre-line;
        margin: 0;
        line-height: 18px;
        background: #f2f2f2;
        border: 1px solid #e8e8e8;
        border-radius: 5px;
        padding: 6px;
        max-height: 127px;
        overflow-y: scroll;
    }
    .status-detail {
        margin-top: 6px;
        color: #606266;
        line-height: 18px;
        white-space: pre-line;
        word-break: break-all;
    }
}

.response-dept{
    .el-button--small{
        padding: 4px 10px;
    }
}
</style>
